import {FriendRoomInviteNotificationData, FriendStatusData, RoomInviteResponse} from '../../../../shared/friends/FriendTypes'
import {UIOnlineFriendController} from '../../../shared/scripts/ui_friends/UIOnlineFriendController'
import {BigId, LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {UIMInviteFriendsBottomDrawer} from '../ui_popup/UIMInviteFriendsBottomDrawer'
import {UIUrlController} from '../../../shared/scripts/ui_html/UIUrlController'
import {notificationController} from '../../../shared/scripts/EntryShared'
import {UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController'

export class UIMOnlineFriendController extends UIOnlineFriendController {
    updateFriendOnlineStatus(friendData: FriendStatusData) {
        UIMInviteFriendsBottomDrawer.updateFriendOnlineStatus(friendData)
        super.updateFriendOnlineStatus(friendData)
    }

    updateAllFriendsOnlineStatus(friends: FriendStatusData[]) {
        UIMInviteFriendsBottomDrawer.updateFriendList(friends)
        super.updateAllFriendsOnlineStatus(friends)
    }

    friendRespondedToRoomInvite(responseData: RoomInviteResponse) {
        if(responseData.response) return
        super.friendRespondedToRoomInvite(responseData)
        UIMInviteFriendsBottomDrawer.friendListController?.toggleFriendInviteButtonState(responseData.responderUserId, true)
    }

    // eslint-disable-next-line class-methods-use-this
    roomInviteSentToFriendSuccessfully(receiverUserId: BigId) {
        const roomId = UIUrlController.getRoomIdFromUrl()
        if(!roomId) return
        UIMInviteFriendsBottomDrawer.friendListController?.toggleFriendInviteButtonState(receiverUserId, false)
    }

    // eslint-disable-next-line class-methods-use-this
    showNotification(icon: LobbyImage, translationObj: TranslationObject) {
        notificationController.showNotification(icon, translationObj)
    }

    // eslint-disable-next-line class-methods-use-this
    showJoinRoomNotification(icon: LobbyImage, translationObj: TranslationObject, roomInvite: FriendRoomInviteNotificationData) {
        notificationController.show(translationObj, UITopNotificationType.Information, {key: 'strings:homePage.ctas.joinRoom'}, () => UIOnlineFriendController.respondToFriendRoomInvite(roomInvite.roomId, true, roomInvite.senderUserId), undefined)
    }
}
